module.exports = __webpack_public_path__ + "static/media/logo_transparent2.45ced1f0.png";